import Badge from 'components/Badge/Badge';

export default Badge;
